export default __webpack_public_path__ + "static/media/iPhone11_postBerenjenaSummary_copy.ca0a160f.png";